<section class="sav-notfound">
  <div class="sav-site-container">
    <div class="sav-notfound-inner">
      <span class="sav-notfound-code">{{ isGone() ? '410' : isUnavailable() ? '503' : '404' }}</span>
      @if (isGone()) {
        <h1>This page has been removed</h1>
        <p>
          This address is no longer part of the site and there is no replacement for it. Start from
          one of these instead.
        </p>
      } @else if (isUnavailable()) {
        <h1>This page is temporarily unavailable</h1>
        <p>
          We couldn't load this page just now. It hasn't gone anywhere — please refresh in a
          moment, or start from one of these.
        </p>
      } @else {
        <h1>We couldn't find that page</h1>
        <p>
          The page you're looking for doesn't exist, or the deal it pointed to has expired. Try one
          of these instead.
        </p>
      }
      <div class="sav-notfound-actions">
        <a class="sav-notfound-btn is-primary" routerLink="/">Back to home</a>
        <a class="sav-notfound-btn" routerLink="/storelist">Browse all stores</a>
        <a class="sav-notfound-btn" routerLink="/categories">Browse categories</a>
      </div>
    </div>
  </div>
</section>
